import { ContainerWithHeader } from "./ContainerWithHeader";
import type { ContainerWithHeaderProps } from "./ContainerWithHeader.d";

export { ContainerWithHeader, ContainerWithHeaderProps };
